'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import EditorComponent from '../..';
// import SlickSlider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Iterable2 = require('../Connectors/Connector/ListView/Iterable');

var _Iterable3 = _interopRequireDefault(_Iterable2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Slider = (_temp = _class = function (_Iterable) {
  _inherits(Slider, _Iterable);

  function Slider() {
    _classCallCheck(this, Slider);

    return _possibleConstructorReturn(this, _Iterable.apply(this, arguments));
  }

  Slider.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _Iterable.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'Slider'));
  }; // prepareDragItemComponents() {
  //   return [
  //     {
  //       "name": "Section",
  //       "props": {
  //         "style": {
  //           "textAlign": "center"
  //         },
  //         "className": "block"
  //       },
  //       "components": [
  //         {
  //           "name": "Tag",
  //           "props": {
  //             "tag": "h1"
  //           },
  //           "components": [
  //             {
  //               "name": "Tag",
  //               "component": "Tag",
  //               "props": {
  //                 "text": "Недвижимость в Дубае, ОАЭ"
  //               },
  //               "components": []
  //             }
  //           ],
  //           "component": "Tag"
  //         },
  //         {
  //           "name": "Tag",
  //           "props": {
  //             "tag": "div",
  //             "className": "caption"
  //           },
  //           "components": [
  //             {
  //               "name": "Tag",
  //               "component": "Tag",
  //               "props": {
  //                 "text": "Квартиры и апартаменты премиум и бизнес-класса в лучших жилых комплексах Дубая"
  //               },
  //               "components": []
  //             }
  //           ],
  //           "component": "Tag"
  //         },
  //         // {
  //         //   "name": "Section",
  //         //   "component": "Section",
  //         //   "props": {
  //         //   },
  //         //   "components": [
  //         //     {
  //         //       "name": "Section",
  //         //       "component": "Section",
  //         //       "props": {
  //         //       },
  //         //       "components": [
  //         //       ],
  //         //     },
  //         //   ],
  //         // },
  //       ],
  //       "component": "Section"
  //     }
  //   ];
  // }
  // getRootElement() {
  //   return MainMenu;
  // }


  Slider.prototype.renderChildren = function renderChildren() {
    var childs = _Iterable.prototype.renderChildren.call(this);

    if (!childs) {
      return childs;
    }

    var SlickSlider = require("react-slick").default;

    return _react2.default.createElement(SlickSlider, this.getSliderProps(), childs);
  };

  Slider.prototype.getSliderProps = function getSliderProps() {
    var _this2 = this;

    var _getComponentProps = this.getComponentProps(this),
        _getComponentProps$sl = _getComponentProps.slidesToShow,
        slidesToShow = _getComponentProps$sl === undefined ? 1 : _getComponentProps$sl,
        other = _objectWithoutProperties(_getComponentProps, ['slidesToShow']);

    var childs = _Iterable.prototype.renderChildren.call(this);

    return _extends({
      ref: function ref(slider) {
        return _this2.slider = slider;
      },
      // Fix issue https://github.com/akiran/react-slick/issues/1553
      slidesToShow: childs.length > slidesToShow ? slidesToShow : childs.length
    }, other);
  };

  Slider.prototype.prepareRootElementProps = function prepareRootElementProps(props) {
    var _Iterable$prototype$p = _Iterable.prototype.prepareRootElementProps.call(this, props),
        dots = _Iterable$prototype$p.dots,
        dotsClass = _Iterable$prototype$p.dotsClass,
        speed = _Iterable$prototype$p.speed,
        slidesToShow = _Iterable$prototype$p.slidesToShow,
        slidesToScroll = _Iterable$prototype$p.slidesToScroll,
        slidesPerRow = _Iterable$prototype$p.slidesPerRow,
        accessibility = _Iterable$prototype$p.accessibility,
        adaptiveHeight = _Iterable$prototype$p.adaptiveHeight,
        arrows = _Iterable$prototype$p.arrows,
        autoplay = _Iterable$prototype$p.autoplay,
        autoplaySpeed = _Iterable$prototype$p.autoplaySpeed,
        centerMode = _Iterable$prototype$p.centerMode,
        centerPadding = _Iterable$prototype$p.centerPadding,
        draggable = _Iterable$prototype$p.draggable,
        easing = _Iterable$prototype$p.easing,
        fade = _Iterable$prototype$p.fade,
        focusOnSelect = _Iterable$prototype$p.focusOnSelect,
        infinite = _Iterable$prototype$p.infinite,
        initialSlide = _Iterable$prototype$p.initialSlide,
        lazyLoad = _Iterable$prototype$p.lazyLoad,
        pauseOnDotsHover = _Iterable$prototype$p.pauseOnDotsHover,
        pauseOnFocus = _Iterable$prototype$p.pauseOnFocus,
        pauseOnHover = _Iterable$prototype$p.pauseOnHover,
        rows = _Iterable$prototype$p.rows,
        slide = _Iterable$prototype$p.slide,
        swipe = _Iterable$prototype$p.swipe,
        swipeToSlide = _Iterable$prototype$p.swipeToSlide,
        touchMove = _Iterable$prototype$p.touchMove,
        touchThreshold = _Iterable$prototype$p.touchThreshold,
        useCSS = _Iterable$prototype$p.useCSS,
        useTransform = _Iterable$prototype$p.useTransform,
        variableWidth = _Iterable$prototype$p.variableWidth,
        vertical = _Iterable$prototype$p.vertical,
        ObjectContext = _Iterable$prototype$p.ObjectContext,
        items = _Iterable$prototype$p.items,
        other = _objectWithoutProperties(_Iterable$prototype$p, ['dots', 'dotsClass', 'speed', 'slidesToShow', 'slidesToScroll', 'slidesPerRow', 'accessibility', 'adaptiveHeight', 'arrows', 'autoplay', 'autoplaySpeed', 'centerMode', 'centerPadding', 'draggable', 'easing', 'fade', 'focusOnSelect', 'infinite', 'initialSlide', 'lazyLoad', 'pauseOnDotsHover', 'pauseOnFocus', 'pauseOnHover', 'rows', 'slide', 'swipe', 'swipeToSlide', 'touchMove', 'touchThreshold', 'useCSS', 'useTransform', 'variableWidth', 'vertical', 'ObjectContext', 'items']);

    return other;
  };

  return Slider;
}(_Iterable3.default), _class.defaultProps = _extends({}, _Iterable3.default.defaultProps, {
  dots: true,
  dotsClass: "slick-dots",
  speed: 500,
  slidesToScroll: 1,
  slidesToShow: 1,
  slidesPerRow: 1,
  accessibility: false,
  adaptiveHeight: false,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  centerMode: false,
  centerPadding: 50,
  draggable: true,
  easing: "linear",
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: undefined,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  // ToDo Add array/json params
  // responsive: array,
  rows: 1,
  slide: "div",
  swipe: true,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  style: _extends({}, _Iterable3.default.defaultProps.style, {
    paddingBottom: 30
  })
}), _class.Name = "Slider", _temp);
exports.default = Slider;
module.exports = exports['default'];